// extracted by mini-css-extract-plugin
export default {"loaderBackdrop":"Loader_loaderBackdrop__bR1-X","fullScreen":"Loader_fullScreen__fNXAQ","loaderContainer":"Loader_loaderContainer__Budva"};